import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';
import { cameraBannerBg } from '@assets/images/main/camera';
import { IconGpsDeviceOff, IconGpsDeviceOn, IconGpsTagOff, IconGpsTagOn, IconOsOff, IconOsOn } from '@assets/images/main/icon';
import { IconBlueShield } from '@assets/images/main/icon/blue';
import { loraGatewayOn, loraGatewayOff, loraSensorOn, loraSensorOff, airOn, airOff, coOn, coOff, IconAlarm } from '@assets/images/main/index';
import { outdoorBannerImg } from '@assets/images/main/outdoor';

export default {
  banner: {
    title: 'Even vast spaces and moving assets,<br/>simplified on the ORBRO screen.',
    desc: 'Track the movement of vehicles, assets, and equipment using GPS,<br/>and synchronize real-time location data to ORBRO OS via LTE and LoRA receivers.',
    schemeTitle: 'Find the right outdoor tracking method for you',
    bgImg: cameraBannerBg,
    productImg: outdoorBannerImg,
  },

  bannerData: [
    { icon: IconGpsDeviceOn, iconInv: IconGpsDeviceOff, image: '', iconText: 'GPS Device', sub: 'New', link: '/en/outdoor/gps' },
    { icon: IconGpsTagOn, iconInv: IconGpsTagOff, image: '', iconText: 'GPS Tag (LoRA)', sub: 'New', link: '/en/outdoor/lora' },
  ],

  func: {
    title: 'Explore Camera Features',
    desc: 'Check out the various features of the camera.',

    data: [
      {
        img: IconBlueShield,
        title: 'Real-time Route Tracking',
        desc: 'Visualize the movement of outdoor assets like vehicles, equipment, and containers in real-time on a map to see both current location and travel history.',
      },
      {
        img: IconAlarm,
        title: 'Zone Setup and Breach Detection',
        desc: 'Designate specific areas like ports, yards, or roadwork zones, and receive automatic alerts when assets enter or leave these areas.',
      },
      {
        img: Icon3dMeter,
        title: 'Equipment Operation Time Analysis',
        desc: 'Analyze operational efficiency by automatically classifying GPS-based operation/wait/idle time of vehicles and heavy machinery.',
      },
      {
        img: Icon3dCycle,
        title: 'Speed Anomaly Detection',
        desc: 'Send alerts to administrators when set speed thresholds are exceeded or unexpected movement patterns are detected.',
      },
      {
        img: Icon3dDetect,
        title: 'Remote Monitoring of GPS Devices',
        desc: 'Remotely monitor battery levels, last communication time, and update frequency of each device, with alerts for abnormal statuses.',
      },
      {
        img: Icon3d3d,
        title: 'Auto-generated Asset Reports',
        desc: 'Automatically generate daily/weekly/monthly reports including location history, stay zones, travel distance, and entry/exit logs.',
      },
    ],
  },

  FAQ: [
    {
      title: 'How does ORBRO’s GPS tracking system work?',
      description:
        'GPS devices calculate real-time locations using GNSS signals and transmit data to the ORBRO Server via LoRA or LTE-M. The location is visualized on a map in ORBRO OS.',
    },
    {
      title: 'What does the LoRA receiver kit do?',
      description:
        'The kit receives signals from GPS devices and sends them to the ORBRO Server via wired (PoE) communication. It enables real-time data syncing over large areas.',
    },
    {
      title: 'Can it be used in areas without power?',
      description: 'Yes. GPS devices operate up to 150 days on internal battery, making them usable without external power. Receivers require PoE power.',
    },
    {
      title: 'Is real-time tracking possible?',
      description:
        'Yes. Devices transmit location data periodically and it’s updated on the server almost in real time. Transmission intervals can be adjusted (typically 10s–1min).',
    },
    {
      title: 'Is GPS tracking better than indoor RTLS?',
      description:
        'It depends. GPS works best outdoors in wide open areas, while RTLS is ideal for high-precision indoor tracking. ORBRO supports integrated indoor-outdoor tracking.',
    },
    {
      title: 'Is the location data stored?',
      description:
        'Yes. Location data is stored in the ORBRO Server and used for asset movement history, access logs, and stay duration analysis. All data is securely managed.',
    },
    {
      title: 'Can I check device status?',
      description: 'Yes. Battery level, last contact time, and signal quality are remotely visible in ORBRO OS. Alerts are sent automatically if issues occur.',
    },
    {
      title: 'Are real-time alerts available?',
      description: 'Yes. Real-time alerts (push, email, webhook, etc.) can be sent when assets leave defined zones, behave abnormally, or exceed speed limits.',
    },
  ],
};
